module.exports = __webpack_public_path__ + "img/saint-pierre-and-miquelon.3862537b.svg";